import {
  EnvironmentProviders,
  Provider,
  inject,
  provideAppInitializer,
} from '@angular/core';
import {
  provideRouter,
  withExperimentalAutoCleanupInjectors,
  withInMemoryScrolling,
  withPreloading,
  withRouterConfig,
} from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideCbUi } from '@cbui/providers';
import { provideIonicAngular } from '@ionic/angular';
import { Store, provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';

import { AppState } from '@cbcore/NGRX/core.state';
import { Config } from '@cbcore/services/config/config.service';
import { provideCbfeCore } from '@cbcore/cbfe-core.config';
import { routes } from './app.routes';
import { CustomPreloadingStrategyService } from '@app/custom-preloading-strategy';
import { MerchantConfig } from './config/config.service';
import { MerchantService } from './services/merchant';
import { MerchantEffects } from './config/NGRX/merchant/merchant.effects';
import { merchantReducer } from './config/NGRX/merchant/merchant.reducer';
import { AppConfig } from './app.config.service';
import { provideTranslation } from './providers/translation.providers';
import { provideEnvironmentTokens } from './providers/environment.providers';

export function MerchantConfigFactory(store: Store<AppState>): any {
  return new MerchantConfig(store);
}

export const appProviders: Array<Provider | EnvironmentProviders> = [
  provideRouter(
    routes,
    withPreloading(CustomPreloadingStrategyService),
    withInMemoryScrolling({ scrollPositionRestoration: 'enabled' }),
    withRouterConfig({ paramsInheritanceStrategy: 'always' }),
    withExperimentalAutoCleanupInjectors(),
  ),

  provideAnimations(),

  provideCbfeCore(),
  provideState('merchant', merchantReducer),
  provideEffects(MerchantEffects),

  ...provideTranslation(),
  ...provideEnvironmentTokens(),

  {
    provide: Config,
    useFactory: MerchantConfigFactory,
    deps: [Store],
  },
  MerchantService,
  AppConfig,
  provideCbUi(),
  provideIonicAngular(),

  provideAppInitializer(() => {
    const appConfigService = inject(AppConfig);
    return appConfigService.loadInitialData();
  }),
];
